export default __webpack_public_path__ + "static/media/kinectrics.1ea27811.png";